"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _Category = _interopRequireDefault(require("./Category"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _dontCollapseCheckboxes = require("../../actions/data/filters/dontCollapseCheckboxes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// TODO: Move this into Containers folder
var CharacteristicsFilters = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CharacteristicsFilters, _React$Component);

  function CharacteristicsFilters() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CharacteristicsFilters.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    // Turn off value so we don't reset again
    if (this.props.collapseCheckboxes) {
      this.props.dontCollapseCheckboxes();
    }
  };

  _proto.render = function render() {
    var _this = this;

    var categories = this.props.characteristics.categories;
    var _this$props = this.props,
        hasAccess = _this$props.hasAccess,
        noAccessAction = _this$props.noAccessAction;
    return /*#__PURE__*/React.createElement("ul", {
      className: "characteristics-filter"
    }, categories.map(function (category, key) {
      return /*#__PURE__*/React.createElement(_Category["default"], {
        value: category,
        key: key,
        shouldReset: _this.props.collapseCheckboxes,
        hasAccess: hasAccess,
        noAccessAction: noAccessAction
      });
    }));
  };

  return CharacteristicsFilters;
}(React.Component); // get something out of global store


var mapStateToProps = function mapStateToProps(state, props) {
  return {
    collapseCheckboxes: state.dataPages.collapseCheckboxes
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    dontCollapseCheckboxes: _dontCollapseCheckboxes.dontCollapseCheckboxes
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CharacteristicsFilters);

exports["default"] = _default;